import { firestore } from "./firebaseConfig";

// method collection to get required connection

export const usersCollection = firestore.collection("users");
export const reportsCollection = firestore.collection("reports");
export const parkingsCollection = firestore.collection("parkings");
export const bookingsCollection = firestore.collection("bookings");
